import React from 'react';
import Grid from '../layout/grid';

export default props => {
  const isChecked = props.input && props.input.value;

  return (
    <Grid cols={props.cols}>
      <div className="checkbox" style={{ position: 'relative' }}>
        <label htmlFor={props.name} style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              marginRight: '4px',
            }}
          >
            <input
              {...props.input}
              readOnly={props.readOnly}
              type={props.type}
              id={props.id}
              className={props.className}
              disabled={props.disabled}
              style={{
                width: '18px',
                height: '18px',
                margin: '0',
                accentColor: '#337ab7',
                position: 'absolute',
                top: '0',
                left: '0',
              }}
            />
            {isChecked && (
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '18px',
                  height: '18px',
                  backgroundColor: '#337ab7',
                  border: '2px solid #337ab7',
                  borderRadius: '3px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  pointerEvents: 'none',
                  zIndex: 1,
                }}
              >
                <span
                  style={{
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    lineHeight: '1',
                  }}
                >
                  ✓
                </span>
              </div>
            )}
          </div>
          {props.label}
        </label>
      </div>
    </Grid>
  );
};
